import _ from 'lodash';
import {rulesMap} from 'go/components/rules/rules';

export default (config, data) => {
  let result = validateCurrent(config, data, {
    errorObj: {},
    contentValid: true,
  });
  return result.contentValid;
};

export const validateCurrent = (config, data, result) => {
  const {validations, contents} = config;
  let errorObj = result.errorObj;
  let contentValid = result.contentValid;

  if (validations) {
    for (let i = 0; i < validations.length; i++) {
      let val = validations[i];
      let field = val.field;
      let v = getData(data, field);
      let errors = validateRules(data, v, val.rules, []);
      let setResponse = setErrorObjects(errorObj, field, errors, contentValid);
      contentValid = setResponse.contentValid;
      errorObj = setResponse.errorObj;
    }
  }

  if (contents) {
    contents.forEach((content) => {
      let contentResult = validateCurrent(content, data, {
        errorObj,
        contentValid,
      });
      errorObj = contentResult.errorObj;
      contentValid = contentResult.contentValid;
    });
  }

  return {errorObj, contentValid};
};

const setErrorObjects = (errorObj, field, errors, contentValid) => {
  let anyErrors = !_.isEmpty(errors);
  if (anyErrors) {
    contentValid = false;
    errorObj = _.setWith(errorObj, field, errors);
  }
  return {errorObj, contentValid};
};

const validateRules = (data, fieldValue, rules, errors) => {
  for (let rule of rules) {
    // Dependencies get added after args
    let ruleArgs = rule.args ? rule.args.slice() : [];
    ruleArgs.push(...getDependencies(data, rule));

    let myRule = rulesMap[rule.method](...ruleArgs);
    let myRuleResult;
    // if there are nested rules, we need to pass those back
    const nestedRulesComposed = _.get(myRule, 'nestedRulesComposed');
    if (nestedRulesComposed !== undefined) {
      let nestedRulesData = [];
      for (var i = 0; i < ruleArgs.length; i++) {
        let nestedRule = ruleArgs[i];
        let currArgs = nestedRule.args ? nestedRule.args.slice() : [];
        let fieldData = fieldValue;
        // ruleArgs contains the rules themselves
        currArgs.push(...getDependencies(data, nestedRule));
        let argumentObj = {
          fieldData: fieldData,
          args: currArgs,
        };
        nestedRulesData.push(argumentObj);
      }
      myRuleResult = nestedRulesComposed(nestedRulesData);
    } else {
      myRuleResult = myRule(fieldValue);
    }
    if (!myRuleResult) {
      errors.push(rule.message);
    }
  }
  return errors;
};

const getDependencies = (data, rule) => {
  let depArgs = [];
  if (rule.dependencies) {
    rule.dependencies.forEach((dep) => {
      let myDepValue = getData(data, dep);
      depArgs.push(myDepValue);
    });
  }
  return depArgs;
};

const getData = (data, dataPath) => {
  return _.get(data, dataPath);
};
